import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import PublicSite from './pages/PublicSite';
import BewerbenPage from './pages/BewerbenPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import BandProfilePage from './pages/BandProfilePage';

const AdminLogin = lazy(() => import('./components/admin/AdminLogin'));
const AdminLayout = lazy(() => import('./components/admin/AdminLayout'));
const AdminDashboard = lazy(() => import('./components/admin/AdminDashboard'));
const AdminEvents = lazy(() => import('./components/admin/AdminEvents'));
const AdminEventDetail = lazy(() => import('./components/admin/AdminEventDetail'));
const AdminLineup = lazy(() => import('./components/admin/AdminLineup'));
const AdminApplications = lazy(() => import('./components/admin/AdminApplications'));
const AdminGallery = lazy(() => import('./components/admin/AdminGallery'));
const AdminNewsletter = lazy(() => import('./components/admin/AdminNewsletter'));
const AdminSettings = lazy(() => import('./components/admin/AdminSettings'));
const AdminUsers = lazy(() => import('./components/admin/AdminUsers'));
const AdminMyAccount = lazy(() => import('./components/admin/AdminMyAccount'));

function AdminFallback() {
  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center">
      <div className="text-gray-500 text-sm">Laden...</div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicSite />} />
        <Route path="/bewerben" element={<BewerbenPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/band-profil/:token" element={<BandProfilePage />} />
        <Route path="/admin/login" element={<Suspense fallback={<AdminFallback />}><AdminLogin /></Suspense>} />
        <Route path="/admin" element={<Suspense fallback={<AdminFallback />}><AdminLayout /></Suspense>}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Suspense fallback={<AdminFallback />}><AdminDashboard /></Suspense>} />
          <Route path="events" element={<Suspense fallback={<AdminFallback />}><AdminEvents /></Suspense>} />
          <Route path="events/:eventId" element={<Suspense fallback={<AdminFallback />}><AdminEventDetail /></Suspense>} />
          <Route path="events/:eventId/lineup" element={<Suspense fallback={<AdminFallback />}><AdminLineup /></Suspense>} />
          <Route path="events/:eventId/bewerbungen" element={<Suspense fallback={<AdminFallback />}><AdminApplications /></Suspense>} />
          <Route path="gallery" element={<Suspense fallback={<AdminFallback />}><AdminGallery /></Suspense>} />
          <Route path="newsletter" element={<Suspense fallback={<AdminFallback />}><AdminNewsletter /></Suspense>} />
          <Route path="settings" element={<Suspense fallback={<AdminFallback />}><AdminSettings /></Suspense>} />
          <Route path="users" element={<Suspense fallback={<AdminFallback />}><AdminUsers /></Suspense>} />
          <Route path="users/me" element={<Suspense fallback={<AdminFallback />}><AdminMyAccount /></Suspense>} />
          <Route path="event" element={<Navigate to="/admin/events" replace />} />
          <Route path="lineup" element={<Navigate to="/admin/events" replace />} />
          <Route path="bewerbungen" element={<Navigate to="/admin/events" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
